;
"use strict";

/// <summary>Renders 16:9 iframe with specified url</summary>
/// <param name="url">The &lt;iframe>url of the iframe</param>
/// <param name="linkUrl">url for fallback link, provide in case it should be different than iframe url</param>
/// <remarks>Used by External Content feature linked to key Multimedia.ExternalMultimedia.ProviderRulesJSON. It searches for first occurence of element with specified class. After processing it will rename it to something-rendered, so next call can process another element</remarks>
window.renderExternalContent = function (url, linkUrl) {
    var placeholder = $dom.get(".external-content-placeholder")[0];
    var ifr = document.createElement("iframe");
    var params = RFE.getURLParams(url);

    // to enable iframe JS API
    if (!params['enablejsapi'] || params['enablejsapi'] == 0) url = url + (url.indexOf('?') > -1 ? '&' : '?') + "enablejsapi=1";
    // to disable auto fullscreen mode on iOS
    if (RFE.isMobile.iPhone() && (!params['playsinline'] || params['playsinline'] == 0)) url = url + "&playsinline=1";

    // to add rel=0 param and id with player in a name for adobe analytics to work
    if (url.indexOf('youtube.com') > -1) {

        if (!params['rel'] || params['rel'] == 0) url = url + (url.indexOf('?') > -1 ? '&' : '?') + "rel=0";
        ifr.setAttribute("id", "player" + Math.floor((Math.random() * 10000)));
    }
    if (url.indexOf('pangeaEmbed=true') > -1) {
        var hostname;
        //find & remove protocol (http, ftp, etc.) and get hostname
        if (url.indexOf("//") > -1) {
            hostname = url.split('/')[2];
        }
        else {
            hostname = url.split('/')[0];
        }
        //find & remove port number
        hostname = hostname.split(':')[0];
        //find & remove "?"
        hostname = hostname.split('?')[0];
        //set platform type value
        var platformType = hostname != window.location.hostname ? 'cross-promo' : 'responsive';
        url = url.replace('pangeaEmbed=true', 'platformType=' + platformType);
    }

    ifr.setAttribute("src", url);
    ifr.style.width = "100%";
    ifr.style.height = (params['type']=='audio') ? "144px" : Math.round(placeholder.offsetWidth * 9 / 16) + "px";
    ifr.setAttribute("frameborder", "0");
    ifr.setAttribute("scrolling", "no");
    ifr.style.overflow = "hidden";
    ifr.setAttribute("allowfullscreen", "allowfullscreen");
    ifr.title = "external-frame";

    var href = linkUrl ? linkUrl : url;
    var link = document.createElement("a");
    link.setAttribute("href", href);
    link.setAttribute("target", "_blank");
    link.innerHTML = href;

    // ifr.appendChild(link);
    placeholder.appendChild(ifr);
    $dom.addClass(placeholder, "external-content-rendered");
    $dom.removeClass(placeholder, "external-content-placeholder");

    // calculates proper height when width has been changed (resize, orientationchange)
    window.addEventListener("resize", function() {
        ifr.style.height = (params['type']=='audio') ? "144px" : Math.round(placeholder.offsetWidth * 9 / 16) + "px";
    });
}


//
// main namespace for all RFE sweet things
window.RFE = window.RFE || {};

/**
* Its a provider of "pushed state below" see. replaceURLNoReload
*/
window.onpopstate = function (event) {
    if (event.state) { //skip on load: http://stackoverflow.com/questions/15896434/window-onpopstate-on-page-load
        location.href = location.href;
    };
};

/**
* Result current media query shortcut ("XS"/"SM"/"ME"/"LG")
*/
RFE.getResponsiveState = function getResponsiveState(url) {
    var responsiveIndicator = document.querySelector('.responsive-indicator');
    if ($dom.style(responsiveIndicator.querySelector('.visible-xs-block'), "display") === "block") {
        return "xs";
    } else if ($dom.style(responsiveIndicator.querySelector('.visible-sm-block'), "display") === "block") {
        return "sm";
    } else if ($dom.style(responsiveIndicator.querySelector('.visible-md-block'), "display") === "block") {
        return "md";
    } else if ($dom.style(responsiveIndicator.querySelector('.visible-lg-block'), "display") === "block") {
        return "lg";
    };
}

    /**
    * Change whole URL if possible without reloading
    */
RFE.replaceURLNoReload = function replaceURLNoReload(url) {

if (history && history.pushState) {
    history.pushState({}, "b", url);
}
}

    /**
    * Get position on the page
    */
    RFE.getOffsetFromBody = function getOffset(object, offset) {
        if (!offset) {
            offset = {x: 0, y: 0};
        }

        if (object) {
            offset.x += object.offsetLeft;
            offset.y += object.offsetTop;

            getOffset(object.offsetParent, offset);
        }

        return offset;
    }

//
// Detect mobile browsers -- http://www.abeautifulsite.net/detecting-mobile-devices-with-javascript/
RFE.isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i) && !RFE.isMobile.Windows();
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return (navigator.userAgent.match(/iPhone|iPad|iPod/i) && !RFE.isMobile.Windows())
        // navigato.platform is deprecated, BUT should solve the New iPad nonsense
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    },
    iPhone: function () {
        return navigator.userAgent.match(/iPhone/i) && !RFE.isMobile.Windows();
    },
    iPad: function () {
        return (navigator.userAgent.match(/iPad/i) && !RFE.isMobile.Windows())
        // navigato.platform is deprecated, BUT should solve the New iPad nonsense
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    },
    iPod: function () {
        return navigator.userAgent.match(/iPod/i) && !RFE.isMobile.Windows();
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () { // be careful, IEMobile send also other signatures (iOS + Android)
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (RFE.isMobile.Android() || RFE.isMobile.BlackBerry() || RFE.isMobile.iOS() || RFE.isMobile.Opera() || RFE.isMobile.Windows());
    }
};

RFE.getStyle = function (el, styleProp) {
    if (el.currentStyle)
        var y = el.currentStyle[styleProp];
    else if (window.getComputedStyle)
        var y = document.defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
    return y;
}

RFE.getURL = function () {
    return document.location;
}

/**
* Retuns Object(key-value) of URL params
*/
RFE.getURLParams = function(url) {
    if (!url || url == '' || url === undefined) url = window.location.href;
    if (url.indexOf("?") > -1) {
        url = url.replace("?nocache=1", "");
        var paramsStr = url.substring(url.indexOf("?") + 1);
        var params = {};

        var arr = paramsStr.split("&");
        for (var i = 0; i < arr.length; i++) {
            var paramStr = arr[i];
            if (paramStr.indexOf("=") > -1) {
                var key = paramStr.substring(0, paramStr.indexOf("="));
                var value = paramStr.substring(paramStr.indexOf("=") + 1);
                params[key] = value;
            }
        }
        return params;
    }
    return {};
}

/**
* Check if the site is RTL (returns true) or LTR (returns false)
*/
RFE.isRTL = function (el, styleProp) {
    return document.getElementsByTagName("HTML")[0].getAttribute("dir") === "rtl";
}

//
// Detect the type of RTL scroll mode - like a master here: https://github.com/othree/jquery.rtl-scroll-type
//
//3 Types of scrollLeft (scrollWidth = 100)
//
//Browser       Type        Most Left	Most Right	Initial
//WebKit        default     0           100         100
//Firefox/Opera	negative    -100        0           0
//IE            reverse     100         0           0
//

RFE.getRTLScrollType = function () {
    var definer = $dom.create('div');
    definer.dir = "rtl";
    $dom.style(definer, {
        "font-size": "14px",
        "width": "1px",
        "height": "1px",
        "position": "absolute",
        "top": "-1000px",
        "overflow": "scroll"
    });
    definer.innerHTML = "A";
    document.body.appendChild(definer);

    //style="">A</div>').appendTo('body')[0],

    var type = 'reverse';

    if (definer.scrollLeft > 0) {
        type = 'default';
    } else {
        definer.scrollLeft = 1;
        if (definer.scrollLeft === 0) {
            type = 'negative';
        }
    }

    definer.parentNode.removeChild(definer);
    return type;
}

//
// Attach Event IE8 safe variant
//
RFE.attachEvent = function (element, name, fn) {
    if (element.addEventListener) {
        element.addEventListener(name, fn, false); //allways bubbling
    } else {
        element.attachEvent("on" + name, fn);
    }
}

// Prevent default compatible with ie.
RFE.preventDefault = function (e) {
    e = e || event;
    e.preventDefault ? e.preventDefault() : e.returnValue = false;
    e.stopPropagation ? e.stopPropagation() : e.returnValue = false;
}

// Check that response is valid.
RFE.isResponseValid = function (response) {
    return response && (typeof response === "object" || response instanceof Array);
}

// adapted from matchMedia polyfill
// by Scott Jehl and Paul Irish
// gist.github.com/786768
RFE.testMediaQuery = function () {

    try {
        var mq = window.matchMedia("(min-width: 500px)");
    } catch (e) {
    }

    var matchMedia = window.matchMedia || window.msMatchMedia;
    if (matchMedia) {
        return matchMedia(mq) && matchMedia(mq).matches || false;
    }

    return false;
}

/**
* Add ECMA262-5 Array methods if not supported natively
*/
RFE.indexOf = function (arr, find, i /*opt*/) {
    if (i === undefined) i = 0;
    if (i < 0) i += arr.length;
    if (i < 0) i = 0;
    for (var n = arr.length; i < n; i++)
        if (i in arr && arr[i] === find)
            return i;
    return -1;
};

/**
 * Get elements by attribute.
 * @param {String} attribute Attribute name.
 * @param {HTMLElement} parent Element to search in - optional.
 * @param {String|Function} value Optional value which the lement have to contain.
 *   When function is passed, it's get called for each element with parameters: the attribute
 *   content and the element. When the function returns true, the element is added to the return
 *   array.
 * @returns {Array} Array of matched elements.
 */
RFE.getElementsByAttribute = function (attribute, parent, value) {
    if (typeof parent === "string" || typeof parent === "function") {
        value = parent;
        parent = null;
    }

    if (!parent) {
        parent = document;
    }

    var search = [];
    var elems = parent.getElementsByTagName("*");

    for (var i = 0; i < elems.length; i++) {
        if (!elems[i].hasAttribute(attribute)) {
            continue;
        }

        if (typeof value === "function") {
            if (!value(elems[i].getAttribute(attribute), elems[i])) {
                continue;
            }
        }
        else if (typeof value !== "undefined" && elems[i].getAttribute(attribute) != value) {
            continue;
        }

        search.push(elems[i]);
    }

    return search;
};

/**
 * Find all form data elements.
 * @param {HTMLElement} form Form or other element containing form data elements.
 * @returns {Array} Array of found elements.
 */
RFE.getFormElements = function (form) {
    var search = [];
    var elems = form.getElementsByTagName("*");

    for (var i = 0; i < elems.length; i++) {
        var tag = elems[i].tagName.toLowerCase();
        if (tag !== "input" && tag !== "select" && tag !== "textarea") {
            continue;
        }

        search.push(elems[i]);
    }

    return search;
};


/**
 * DOM aditional methods.
 */

/**
 * Production steps of ECMA-262, Edition 5, 15.4.4.18
 */
if (!Array.prototype.forEach) Array.prototype.forEach = function (callback, thisArg) {
    if (!this) throw "forEach can't be called on null.";
    if (typeof callback !== "function") throw "callback for forEach have to be a function.";

    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
        if (!this[i]) continue;
        callback.call(thisArg, this[i], i, this);
    }
};


/**
 * Asynchronously load script from remote location.
 * @param {String} src Script URL.
 * @param {Function} onload Optinal onload callbeck.
 */
window.loadScript = function (src, onload) {
    if (typeof src !== "string") throw "loadScript: src have to be a string.";

    var script = document.createElement("script");
    if (typeof onload === "function")
        script.onload = onload;

    document.head.appendChild(script);

    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", src);
}

/**
 * Create the first element in given HTML string.
 * @param {String} html HTML to create.
 * @returns {HTMLElement} Created element.
 */
window.createHTML = function (html) {
    var div = document.createElement("DIV");
    div.innerHTML = html;
    var el = div.firstChild;
    while (el) {
        if (el.nodeType === 1)
            return el;
        el = el.nextSibling;
    }
    return null;
};

/**
 * Activate JavaScripts in given element.
 */
HTMLElement.prototype.activateScripts = function () {
    var scripts = this.querySelectorAll("script");
    for (var i = 0; i < scripts.length; i++) {
        var script = document.createElement("script");
        var sc = scripts[i];

        if (sc.type) {
            script.setAttribute("type", sc.type);
        }

        if (sc.src) {
            script.setAttribute("src", sc.src);
            var data = sc.dataset;
            for (var key in data ) {
                script.dataset[key] = data[key];
            }
        }
        else {
            script.text = sc.text;
        }

        var p = sc.parentNode;
        p.insertBefore(script, sc);
        p.removeChild(sc);
    }
};

/**
 * Collect current form data, which should be sent.
 * @returns {Object} Form data.
 */
HTMLFormElement.prototype.getActionData = function (useFormData) {
    if (useFormData) {
        return new FormData(this);
    }

    var elems = this.querySelectorAll("input, select, textarea");
    var data = {};

    for (var i = 0; i < elems.length; i++) {
        var el = elems[i];
        var val = null;

        if (!el.name || el.disabled)
            continue;

        switch (el.tagName.toLowerCase()) {
            case "input":
                switch (el.type) {
                    case "hidden":
                        val = data[el.name] ? data[el.name] : el.value;
                        break;
                    case "radio":
                    case "checkbox":
                        if (!el.checked) continue;
                    default:
                        val = el.value;
                }
                break;

            case "select":
                var item = el.options[el.selectedIndex];
                if (!item) continue;
                val = item.value || item.text;
                break;

            case "textarea":
                val = el.value;
                break;
        }

        data[el.name] = val;
    }

    return data;
};



/**
 * Simple AJAX functions. TODO
 */

function handleResponse(xhr, cbready, mode, readWithAnyStatus) {
    if (typeof cbready !== "function")
        throw "ajax" + mode + ": cbready must be a function!";

    xhr.onreadystatechange = function () {
        if (this.readyState !== 4) return;
        if (this.status === 200 || readWithAnyStatus)
            cbready(parseResponse(this));
        else
            cbready(null);
    };
}

function parseResponse(xhr) {
    var ct = xhr.getResponseHeader("Content-Type");
    if (ct && (/application\/json/).test(ct)) {
        try {
            return JSON.parse(xhr.responseText);
        }
        catch(err) {
            return xhr.responseText;
        }
    }
    else
        return xhr.responseText;
}

function parseData(data) {


    if (typeof FormData !== "undefined" && data instanceof FormData) {
        return data;
    }

    function parseDataNode(name, object, encoded) {
        var ename = encoded ? name : encodeURIComponent(name);
        var param = "";

        function couple(string, encode) {
            return ename + "=" + (encode ? encodeURIComponent(string) : string);
        }

        // %5B .. [
        // %5D .. ]
        switch (typeof object) {
            case "boolean":
                param = couple(object ? "1" : "0");
                break;
            case "undefined":
                param = couple("0");
                break;
            case "number":
                param = couple(object);
                break;
            case "string":
                param = couple(object, true);
                break;
            case "object":
                if (!object)
                    param = couple("0");
                else {
                    var objects = [];
                    if (Array.isArray(object)) {
                        for (var i = 0; i < object.length; i++)
                            objects.push(parseDataNode(ename + "%5B" + i + "%5D", object[i], true));
                    }
                    else {
                        for (var i in object) {
                            if (object.hasOwnProperty(i))
                                object.push(parseDataNode(ename + "%5B" + encodeURIComponent(i) + "%5D", object[i], true));
                        }
                    }

                    param = object.join('&');
                }
        }

        return param;
    }

    var cnt = 0, toSend = "";
    for (var i in data) {
        if (data.hasOwnProperty(i)) {
            if (cnt++ > 0) toSend += "&";
            toSend += parseDataNode(i, data[i]);
        }
    }

    return toSend;
}

/**
 * Check whether the code is invoked inside CMS
 * - the check is based on the presence of base element
 *
 * TODO - remove this functionality, this check should not be called at all.
 *   This is just hotfix for https://jira.pangea-cms.com/browse/PANGEA-6362
 *
 * @returns {Boolean} is inside CMS?
 */
window.isInsideCms = function () {
    var base = document.getElementsByTagName('base');
    return base && base.length > 0;
}

/**
 * Create GET ajax request.
 * @param {String} url Request URL.
 * @param {Object} data Optional data which are serialized at the end of the URL. This parameter can be omitted.
 * @param {Function|Boolean} cbready When passed true, the request is made
 *   synchronously. Otherwise an instance of Function is required. The parameter of
 *   the response is null when the response status is different than 200 OK, when
 *   the response has Content-Type set to application/json the content is parsed and
 *   returned as Object. Otherwise the text content is set.
 * @param {?Object} xhrOptions when passed, all the attributes are set to the xhr object
 * @returns {XMLHttpRequest|Object|String} When the cbready is set as an instance of Function,
 *   XMLHttpRequest is returned. Otherwise the response is parsed the same way as the argument
 *   of the Function which could be passed.
 */
window.ajaxGet = function (url, data, cbready, xhrOptions) {
    if (cbready === undefined) {
        cbready = data;
        data = null;
    }
    else {
        var strdata = parseData(data);
        if (strdata.length > 0) {
            url += (url.indexOf("?") >= 0) ? "&" : "?";
            url += strdata;
        }
    }

    var sync = true;
    if (cbready !== true) sync = false;

    var xhr = new XMLHttpRequest();
    xhr.open("GET", url.split('#')[0], !sync);

    if (!sync) handleResponse(xhr, cbready, "Get");
    if (typeof xhrOptions === "object") {
        for (var i in xhrOptions) {
            xhr[i] = xhrOptions[i];
        }
    }
    if (!isInsideCms()) {
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    }
    xhr.send();

    return sync ? parseResponse(xhr) : xhr;
}


/**
 * Create POST ajax request.
 * @param {String} url Request URL.
 * @param {Object} data Data to POST.
 * @param {Function|Boolean} cbready When passed true, the request is made
 *   synchronously. Otherwise an instance of Function is required. The parameter of
 *   the response is null when the response status is different than 200 OK, when
 *   the response has Content-Type set to application/json the content is parsed and
 *   returned as Object. Otherwise the text content is set.
 * @param {Function} cbstart When set this call is called before XHR is sent.
 * @param {?Object} options addition options.
 *  if options contains an object xhrOptions, all the attributes are set to the xhr object
 *  if options contains a boolean withAnyStatus property, XMLHttpRequest response will be handled with any status code
 * @returns {XMLHttpRequest|Object|String} When the cbready is set as an instance of Function,
 *   XMLHttpRequest is returned. Otherwise the response is parsed the same way as the argument
 *   of the Function which could be passed.
 */
window.ajaxPost = function (url, data, cbready, cbstart, options) {
    var sync = true;
    if (cbready !== true) sync = false;

    var xhr = new XMLHttpRequest();
    if (typeof cbstart === "function") {
        var ret = cbstart(xhr);
        if (ret === false) {
            return false;
        }
    }

    xhr.open("POST", url.split('#')[0], !sync);

    var withAnyStatus = options && options.withAnyStatus;

    if (!sync) {
        handleResponse(xhr, cbready, "Post", withAnyStatus);
    }

    if ((typeof FormData !== "undefined")  &&  (!(data instanceof FormData))) {
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    }
    if (!sync) handleResponse(xhr, cbready, "Post", withAnyStatus);

    if (!isInsideCms()) {
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    }
    if (options) {
        var xhrOptions = options.xhrOptions;
        if (typeof xhrOptions === "object") {
            for (var i in xhrOptions) {
                xhr[i] = xhrOptions[i];
            }
        }
    }
    xhr.send(parseData(data));

    return sync ? parseResponse(xhr) : xhr;
}

/**
 * Create URI from root directory.
 * @param {String} uri Website URI.
 * @returns {String} Full URI.
 */
window.root = function (uri) {
    uri = uri || "";
    if (uri.length > 0 && uri.charAt(0) === "/")
        uri = uri.substr(1);
    return appBaseUrl + uri;
};

RFE.createCookie = function(name, value, days, domain) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    }
    else var expires = "";
    var domainStr = domain ? "; domain=" + domain : "";
    document.cookie = name + "=" + value + expires + domainStr + "; path=/; secure";
}

RFE.readCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

RFE.eraseCookie = function(name, domain) {
    RFE.createCookie(name, "", -1, domain);
}

/**
 * Include CSS from file stored on server
 * @param {String} fileName file name on the server
 */
RFE.loadCSS = function(fileName) {
    var el = document.createElement("link");
    var path = appBaseUrl + "Content/responsive/" + fileName + ".css?cb=" + cacheBuster;
    el.setAttribute("rel", "stylesheet");
    el.setAttribute("href", path);
   document.body.appendChild(el);
}

/**
 * Include font from server font folder dynamicaly by JS
 * @param {String} fontName font family name
 * @param {String} fileName file name on the server
 * @param {?String} fontWeight optional font weight
 */
RFE.loadFont = function(fontName, fileName, fontWeight) {
    var el = document.createElement("style");
    var path = appBaseUrl + "Content/responsive/fonts/" + fileName;
    fontWeight = typeof fontWeight === "undefined" ? "normal" : fontWeight;
    el.setAttribute("type", "text/css");
    el.innerHTML = "@font-face {"
        + "font-family: \"" + fontName + "\";"
        + "src: url('" + path + ".woff2') format('woff2'), url('" + path + ".woff') format('woff');"
        + "font-weight: " + fontWeight + ";"
        + "font-style: normal;"
   + "}";
   document.body.appendChild(el);
}

/**
 * Add an event listener
 * @param {HTMLElement} el DOM element
 * @param {String} eventName name of custom event
 * @param {Function} handler function which will be triggered
 */
RFE.addCustomEventListener = function(el, eventName, handler) {
    if (el.addEventListener) {
        el.addEventListener(eventName, handler);
    } else {
        el.attachEvent('on' + eventName, function() {
            handler.call(el);
        });
    }
}

/**
 * Trigger the event
 * @param {HTMLElement} el DOM element
 * @param {String} eventName name of event which should be triggered
 * @param {customEventInit} customEventInit options
 */
RFE.triggerCustomEvent = function(el, eventName, options) {
    var event;

    var CustomEvIsSupported = (function () {
        try {
            new CustomEvent('test');
            return true;
        } catch (e) {
            return false;
        }
    })();

    if (window.CustomEvent && CustomEvIsSupported) {
        event = new CustomEvent(eventName, options);
    } else {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, options);
    }
    el.dispatchEvent(event);
}

var MutationObserver = window.MutationObserver || window.WebKitMutationObserver,
    eventListenerSupported = window.addEventListener;

/**
 * Register event, that is triggered after the dom is changed
 * @param {HTMLElement} obj DOM element to be observed
 * @param {function} callback triggered after the dom of the element was changed
 */
RFE.observeDOM = function(obj, callback){
    var obs;
    if( MutationObserver ){
        // define a new observer
        obs = new MutationObserver(function(mutations, observer){
            var doCallback = false;
            for (var i = 0; i < mutations.length; i++) {
                doCallback = doCallback || mutations[i].addedNodes.length || mutations[i].removedNodes.length;
            }
            if (doCallback) {
                callback();
            }
        });
        // have the observer observe foo for changes in children
        obs.observe( obj, {
            attributes: true,
            childList:true,
            characterData: true,
            subtree: true
        });
    }
    else if( eventListenerSupported ){
        obj.addEventListener('DOMNodeInserted', callback, false);
        obj.addEventListener('DOMNodeRemoved', callback, false);
    }

    return function() {
        if( MutationObserver && obs ){
            obs.disconnect();
        }
        else if( eventListenerSupported ){
            obj.removeEventListener('DOMNodeInserted', callback, false);
            obj.removeEventListener('DOMNodeRemoved', callback, false);
        }
    }
}

RFE.parseQueryString = function(query) {
    var vars = query.split("&");
    var qs = {};
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (typeof qs[pair[0]] === "undefined") {
            qs[pair[0]] = decodeURIComponent(pair[1]);
        }
        else if (typeof qs[pair[0]] === "string") {
            var arr = [qs[pair[0]], decodeURIComponent(pair[1])];
            qs[pair[0]] = arr;
        }
        else {
            qs[pair[0]].push(decodeURIComponent(pair[1]));
        }
    }
    return qs;
  }

RFE.hasClass = function (className, el) {
    /// <summary>Checks if element contains CSS class</summary>
    /// <param name="className">CSS class to look for</param>
    /// <param name="el">Element to check</param>
    return (el.classList) ? el.classList.contains(className) : new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
}
RFE.addClass = function (className, el) {
    /// <summary>Adds CSS class to element</summary>
    /// <param name="className">CSS class to add</param>
    /// <param name="el">Element or NodeList to add CSS class to</param>
    var addClassSingle = function (el) {
        if (el.classList)
            el.classList.add(className);
        else
            el.className += ' ' + className;
    }

    if (el instanceof NodeList) {
        for (i = 0; i < el.length; ++i) {
            addClassSingle(el[i]);
        }
    } else {
        addClassSingle(el);
    }
}
RFE.removeClass = function (className, el) {
    /// <summary>Removes CSS class to element</summary>
    /// <param name="className">CSS class to remove</param>
    /// <param name="el">Element or NodeList to remove CSS class from</param>
    var removeClassSingle = function (el) {
        if (el.classList)
            el.classList.remove(className);
        else
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    if (el instanceof NodeList) {
        for (i = 0; i < el.length; ++i) {
            removeClassSingle(el[i]);
        }
    } else {
        removeClassSingle(el);
    }
}
RFE.select = function (selector, context) {
    /// <summary>Select elements by DOM selector</summary>
    /// <param name="selector">selector text</param>
    /// <param name="context">Context DOM object to select from in needed</param>
    /// <returns>List containing DOM Object(s)</summary>
    return (context || document).querySelectorAll(selector);
}
RFE.filter = function (array, fcn) {
    /// <summary>filters array by applying given function to each item</summary>
    /// <param name="array">array to filter</param>
    /// <param name="fcn">function to check each array item against</param>
    /// <remarks>Function must return value which can be interpreted as boolean</remarks>
    /// <returns>filtered array</summary>
    if (!Array.prototype.filter) {
        Array.prototype.filter = function (fun) {
            var len = this.length >>> 0;
            var res = [];
            var thisp = arguments[1];
            for (var i = 0; i < len; i++) {
                if (i in this) {
                    var val = this[i];
                    if (fun.call(thisp, val, i, this))
                        res.push(val);
                }
            }
            return res;
        };
    }
    return array.filter(fcn);
}
RFE.isVisible = function (el) {
    /// <summary>Checks if DOM element is visible.</summary>
    /// <param name="el">Element to check</param>
    if (el === undefined) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
}
RFE.offset = function (el) {
    /// <summary>Computes left and top offsets of given element.</summary>
    /// <param name="el">Element to get offset for</param>
    /// <returns>Anonymous Object with left and top property</summary>
    var rect = el.getBoundingClientRect();
    return { top: rect.top + document.body.scrollTop, left: rect.left + document.body.scrollLeft };
}
RFE.position = function (el) {
    /// <summary>Computes left and top positions of given element.</summary>
    /// <param name="el">Element to get positions for</param>
    /// <returns>Anonymous Object with left and top property</summary>
    return { left: el.offsetLeft, top: el.offsetTop };
}
RFE.outerWidth = function (el) {
    /// <summary>Gets outer width with incl. margins</summary>
    /// <param name="el">Element to get outer width for</param>
    var width = el.offsetWidth;
    var style = getComputedStyle(el);
    width += parseInt(style.marginLeft) + parseInt(style.marginRight);
    return width;
}
RFE.show = function (el) {
    /// <summary>Makes element visible</summary>
    /// <param name="el">Element to get visible</param>
    if (el && el.style)
        el.style.display = 'block'; //due to IE compat. Inline elements will require separate show function if needed
}
RFE.hide = function (el) {
    /// <summary>Makes element invisible with 0 size</summary>
    /// <param name="el">Element to get invisible with 0 size</param>
    if (el && el.style)
        el.style.display = 'none';
}
RFE.data = function (el, name, value) {
    /// <summary>Gets data from data attribute</summary>
    /// <param name="el">Name of data property to obtain</param>
    /// <param name="name">Data name</param>
    /// <param name="value">Value to set to data attribute</param>
    /// <returns>Textual value fo data attribute</returns>
    if (el) {
        if (!value) {
            if (el.dataset && el.dataset[name])
                return el.dataset[name];
            else
                return el.getAttribute('data-' + name);
        } else {
            if (el.dataset)
                el.dataset[name] = value;
            else
                el.setAttribute('data-' + name, value);
        }
    } else {
        return null;
    }
}
RFE.selectParent = function (element, className) {
    /// <summary>Gets the first parent element with requested class name</summary>
    /// <param name="element">Starting element</param>
    /// <param name="className">CSS class name which is used as selector for target element</param>
    var elementsParent = false;
    var parent = (element) ? element.parentNode : false;
    if (parent) {
        do {
            if (RFE.hasClass(className, parent)) {
                elementsParent = parent;
            }
            else {
                parent = parent.parentNode;
                if (!parent)
                    return false;
            }
        }
        while (!elementsParent);
    }
    return elementsParent;
}


RFE.isChildOf = function (child, parent) {
    /// <summary>Checks if the parent is direct or indirect parentNode of child element.</summary>
    /// <param name="child">Child DOM element</param>
    /// <param name="parent">parent DOM element which should be tested if it is parent of child</param>
    if (child.parentNode === parent) {
        return true;
    } else if (child.parentNode === null) {
        return false;
    } else {
        return RFE.isChildOf(child.parentNode, parent);
    }
}

RFE.closest = function (el, sel) {
    /// <summary>Finds closest parent by selector</summary>
    /// <param name="el">Element to search parents of</param>
    /// <param name="sel">Selector to match parent</param>
    if (typeof el.closest === 'function')
        return el.closest(sel) || null;
    if (!Element.prototype.matches) //ie fix
        Element.prototype.matches = Element.prototype.msMatchesSelector;
    while (el) {
        if (el.matches(sel))
            return el;
        el = el.parentElement;
    }
    return null;
}

RFE.isDescendant = function (parent, child) {
    /// <summary>Checks if the element have given element as parent</summary>
    /// <param name="parent">Parent element to search for</param>
    /// <param name="child">Child element that has to be tested</param>
    var node = child.parentNode;
    while (node != null) {
        if (node == parent)
            return true;
        node = node.parentNode;
    }
    return false;
}

RFE.isStickyPersistent = function (el) {
    /// <summary>Checks if the element is persistent sticky (inside persistent sticky container)</summary>
    /// <param name="el">Element to check</param>
    /// <returns>Persistent sticky container or null</returns>
    return RFE.closest(el, ".stickyPersistencyPlayer");
}

/**
 * Creates a new function which is run only once within a specified time range
 * This function is typically used for groupping multiple keypress events to react to the user input after the user
 * finish his typing
 * @param {function} callback the callback function to be debounced
 * @param {number} timeout a time in milliseconds
 * @returns {function} a function with the same input arguments signature as a callback function
 */
RFE.debounce = function(callback, timeout) {
    var to = null;
    return function() {
        var fcnArguments = arguments;
        if (to) {
            window.clearTimeout(to);
            to = null;
        }
        to = window.setTimeout(function() {
            callback.apply(null, fcnArguments);
        }, timeout);
    }
}



//////////////////
// WEBPACK FOOTER
// ./source/js/loader/loader-utils.js
// module id = 20
// module chunks = 0